import React, { useReducer } from "react";
import { Button, Form, Modal, TextArea } from "semantic-ui-react";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";
import { server } from "../../../App";
import axios from "axios";
import { useSelector } from "react-redux";
import { selectisAuthenticated } from "../../../features/auth/authSlice";
import { selectPatientelleGrid } from "../../../features/patientelle/patientelleSlice";

function Note(props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const AuthState = useSelector(selectisAuthenticated);
  const PatientelleState = useSelector(selectPatientelleGrid);
  const { syncData } = props;

  const onValueChanged = async () => {
    const ValuesToCreate = {
      fk_id_patientConsul: PatientelleState.idpatient,
      created_by: AuthState.user_name,
      od: state.FormData.value,
      observation: "-",
      fk_id_examen: 1,
    };

    axios({
      method: "post",
      responseType: "json",
      url: `${server}Consultation`,
      data: ValuesToCreate,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        syncData(response.data);
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };
  return (
    <>
      <Button

        color="black"
        onClick={() => dispatch({ type: ACTION.OPEN, size: "small" })}
      >
        Note
      </Button>
      <Modal
        size={state.size}
        open={state.open}
        onClose={() => dispatch({ type: ACTION.CLOSE })}
      >
        <Modal.Header>Ajouter une Note</Modal.Header>
        <Modal.Content>
          {/*     {(e,data) => dispatch({ type: ACTION.Fill_FORM_DATA, payload: data })} */}
          <Form>
            <TextArea
              autoFocus
              placeholder="Ajouter une Note"
              onInput={(e, data) =>
                dispatch({ type: ACTION.Fill_FORM_DATA, payload: data })
              }
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button color="blue" onClick={() => dispatch({ type: ACTION.CLOSE })}>
            Retour
          </Button>
          <Button positive onClick={onValueChanged}>
            Valider
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}

export default Note;
